<template>
    <div :class="containerClass" v-if="isLogueado == false && isLogueadoPDV == false && hasToken == false">
        <div class="login-container" v-if="resetToken === ''">
            <div class="login-header">
                <img src="/assets/layout/images/logo.png" class="logo" v-if="isLogueado == false && isLogueadoPDV == false && hasToken == false" />
            </div>
            <div class="login-panel-content">
                <div class="p-grid" v-if="server === 'backend'">
                    <div class="p-col-12">
                        <h2><strong>¡Bienvenido!</strong><br /><br />Por favor ingrese sus datos de acceso:</h2>
                    </div>
                    <div class="p-col-12">
                        <span class="p-float-label">
                            <InputText v-model="usuario" id="usuario" type="text" :class="{ 'p-inputwrapper-focus': autofilled }" @keyup.enter="login"
                                ref="usuarioInput" @animationstart="checkAnimation" />
                            <label for="usuario">Usuario / Email</label>
                        </span>
                    </div>
                    <div class="p-col-12">
                        <span class="p-float-label">
                            <InputText v-model="password" id="password" type="password" :class="{ 'p-inputwrapper-focus': autofilled }" @keyup.enter="login" />
                            <label for="password">Contraseña</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <Button label="¿Olvidó su contraseña?" class="p-button-link" />
                    </div>
                    <div class="p-col-12 p-md-6">
                        <Button label="INGRESAR" style="width: 100%" @click="login" />
                    </div>
                    <div class="p-col-12 status p-mt-3" v-html="loginStatus"></div>
                </div>
                <div class="p-grid" v-if="server === 'pdv'">
                    <div class="p-col-12">
                        <h2><strong>Punto de Venta</strong><br /><br />Ingrese contraseña:</h2>
                    </div>
                    <div class="p-col-12">
                        <span class="p-float-label">
                            <InputText v-model="password" id="password" type="password" :class="{ 'p-inputwrapper-focus': autofilled }"
                                @keyup.enter="loginPDV" />
                            <label for="password">Contraseña</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-12">
                        <Button label="INGRESAR" style="width: 100%" @click="loginPDV" />
                    </div>
                    <div class="p-col-12 status p-mt-3" v-html="loginStatus"></div>
                </div>
            </div>
        </div>
        <div class="login-container reset-container" v-if="resetToken !== ''">
            <div class="login-header">
                <img src="assets/layout/images/logo.png" class="logo" v-if="isLogueado == false && isLogueadoPDV == false && hasToken == false" />
            </div>
            <div class="login-panel-content">
                <div class="p-grid">
                    <div class="p-col-12">
                        <h2><strong>¡Bienvenido!</strong><br /><br />Por favor ingrese su nueva contraseña:</h2>
                    </div>
                    <div class="p-col-12">
                        <span class="p-float-label">
                            <InputText v-model="resetNuevoPassword" id="resetNuevoPassword" ref="resetNuevoPassword" type="password"
                                :class="{ 'p-inputwrapper-focus': autofilled }" @keyup.enter="resetAplicarNuevoPassword" />
                            <label for="resetNuevoPassword">Contraseña</label>
                        </span>
                    </div>
                    <div class="p-col-12">
                        <Button :label="grabando ? 'GUARDANDO ...' : 'GUARDAR'" :loading="grabando" style="width: 100%" @click="resetAplicarNuevoPassword" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div :class="containerClass" class="cargando" v-if="isLogueado == false && isLogueadoPDV == false && hasToken == true">
        <img src="/assets/layout/images/logo.png" class="logo" />
        <h2>Cargando ...</h2>
    </div>
    <div :class="containerClass" v-if="isLogueado && tienePasswordTemporal">
        <div class="login-container reset-container">
            <div class="login-header"><img src="assets/layout/images/logo.png" class="logo" /></div>
            <div class="login-panel-content">
                <div class="p-grid">
                    <div class="p-col-12">
                        <h2><strong>¡Bienvenido!</strong><br /><br />Para continuar, debe ingresar una nueva contraseña:</h2>
                    </div>
                    <div class="p-col-12">
                        <span class="p-float-label">
                            <InputText v-model="temporalNuevoPassword" id="temporalNuevoPassword" ref="temporalNuevoPassword" type="password"
                                :class="{ 'p-inputwrapper-focus': autofilled }" @keyup.enter="temporalAplicarNuevoPassword" />
                            <label for="temporalNuevoPassword">Contraseña</label>
                        </span>
                    </div>
                    <div class="p-col-12">
                        <Button :label="grabando ? 'GUARDANDO ...' : 'GUARDAR'" :loading="grabando" style="width: 100%" @click="temporalAplicarNuevoPassword" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div :class="containerClass" class="cargando tyc-layout" v-if="isLogueado && $store.state.auth.usuario.nivel !== 6 && faltanTYC">
        <img src="/assets/layout/images/logo.png" class="logo" />
        <div class="pedido">
            {{
            $store.state.auth.usuario.tyc_aprobado > 0
            ? 'Nuestros Términos y Condiciones han sido actualizados.'
            : 'Por favor lea y acepte nuestros Términos y Condiciones para continuar.'
            }}
        </div>
        <h2>Términos y Condiciones</h2>
        <h6>Versión {{ tyc.id }} - Actualizada {{ fechaTYC() }}</h6>
        <div class="tyc-container" v-html="tyc.contenido"></div>
        <div class="checkboxContainer">
            <Checkbox id="binary" v-model="aceptoTerminos" :binary="true" />
            <label for="binary"> Acepto los Términos y Condiciones.</label>
        </div>
        <Button @click="continuarYAceptarTerminos" :label="grabando ? 'Procesando ...' : 'Continuar'" :loading="grabando" class="p-button-lg p-mt-5"
            style="flex-shrink: 0" />
    </div>
    <div :class="containerClass" class="cargando aviso-layout" v-if="isLogueado && $store.state.auth.usuario.nivel === 6">
        <img src="/assets/layout/images/logo.png" class="logo" />

        <!-- <h2>XXX</h2>
        <h6>Versión {{ tyc.id }} - Actualizada {{ fechaTYC() }}</h6> -->
        <div class="aviso-container">Este portal es para uso exclusivo de Administradores y Proveedores.<br />Debes ingresar por la APP Karga Digital desde tu
            smartphone.<br /><br />
            <div class="qrContainer">
                <div>
                    Descargar ahora para Android<br />
                    <a href="https://play.google.com/store/apps/details?id=com.karga.app" target="_blank"><img src="/assets/descargar-google-play.png"
                            class="descargar" /></a><br />
                    <img src="/assets/qr-android.png" class="qr" />
                </div>
                <div>
                    Descargar ahora para iOS<br />
                    <a href="#"><img src="/assets/descargar-app-store.png" class="descargar" /></a><br />
                    <img src="/assets/qr-ios.png" class="qr" />
                </div>
            </div>
        </div>
        <Button @click="cerrarSesion" label="Cerrar Sesión" class="p-button-lg p-mt-5" style="flex-shrink: 0" />
    </div>
    <div :class="containerClass" @click="onWrapperClick" v-if="isLogueado && !faltanTYC">
        <AppTopBar @menu-toggle="onMenuToggle" />
        <transition name="layout-sidebar">
            <div :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
                <div class="layout-logo">
                    <router-link to="/">
                        <img alt="Logo" :src="logo" />
                    </router-link>
                </div>

                <AppProfile />
                <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
            </div>
        </transition>

        <div class="layout-main">
            <router-view />
        </div>
    </div>
    <div :class="containerClass" @click="onWrapperClick" v-if="isLogueadoPDV && !faltanTYC">
        <AppTopBar @menu-toggle="onMenuToggle" @ver-qr="verQRPDV()" :sinMenu="true" />
        <div class="layout-main">
            <router-view />
        </div>
    </div>
    <Dialog :header="alertaOpciones.titulo" v-model:visible="alertaVisible" @hide="cerrarAlerta" :breakpoints="{ '960px': '75vw' }" :style="{ width: '30vw' }"
        :modal="true">
        <p v-html="alertaOpciones.contenido"></p>
        <template #footer>
            <Button :label="alertaOpciones.botonCerrar" @click="cerrarAlerta" icon="pi pi-check" class="p-button-secondary" />
        </template>
    </Dialog>
</template>

<script>
import AppTopBar from './AppTopbar.vue'
import AppProfile from './AppProfile.vue'
import AppMenu from './AppMenu.vue'
import getMenu from './menu'
import EventBus from '@/AppEventBus'
import TYCsService from './service/TYCsService'
import moment from 'moment'
import UsuariosService from './service/UsuariosService'
import { chequearRuta } from './router'

export default {
    data() {
        return {
            usuario: '',
            password: '',
            layoutMode: 'static',
            layoutColorMode: 'dark',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            alertaVisible: false,
            alertaOpciones: {},
            autofilled: false,
            tyc: {},
            aceptoTerminos: false,
            grabando: false,
            resetNuevoPassword: '',
            temporalNuevoPassword: '',
        }
    },
    watch: {
        $route() {
            this.menuActive = false
            this.$toast.removeAllGroups()
            if (this.mobileMenuActive) {
                this.onMenuToggle()
            }
        },
        isLogueado() {
            this.usuario = ''
            this.password = ''
        },
        isLogueadoPDV() {
            this.password = ''
        },
    },
    methods: {
        checkAnimation(e) {
            console.log(`checkAnimation ${e.animationName}`)
            if (e.animationName.includes('onAutoFillStart')) {
                this.autofilled = true
            } else if (e.animationName.includes('onAutoFillCancel')) {
                this.autofilled = false
            }
        },
        verQRPDV() {
            EventBus.emit("ver-qr", {});
        },
        async resetAplicarNuevoPassword() {
            if (this.resetNuevoPassword.trim() === '') {
                this.mostrarAlerta({
                    titulo: 'Error',
                    contenido: 'Debe ingresar una nueva contraseña.',
                    botonCerrar: 'Ok',
                    cerrarCallback: () => {
                        this.$refs.resetNuevoPassword.$el.focus()
                    },
                })
                return
            }

            if (this.resetNuevoPassword.trim().length < 8) {
                this.mostrarAlerta({
                    titulo: 'Error',
                    contenido: 'La nueva contraseña debe tener al menos 8 caracteres.',
                    botonCerrar: 'Ok',
                    cerrarCallback: () => {
                        this.$refs.resetNuevoPassword.$el.focus()
                    },
                })
                return
            }

            this.grabando = true

            const respuesta = await UsuariosService.resetPassword({
                token: this.resetToken,
                password: this.resetNuevoPassword.trim(),
            })

            if (respuesta.success === true) {
                this.mostrarAlerta({
                    titulo: 'Listo!',
                    contenido: 'La nueva contraseña fue aplicada.',
                    botonCerrar: 'Ok',
                    cerrarCallback: () => {
                        window.location.href = '/'
                    },
                })
            } else {
                this.mostrarAlerta({
                    titulo: 'Error',
                    contenido: `La nueva contraseña no se pudo aplicar:<Br />${respuesta.error}`,
                    botonCerrar: 'Ok',
                    cerrarCallback: () => {
                        this.$refs.resetNuevoPassword.$el.focus()
                    },
                })
            }
        },
        async temporalAplicarNuevoPassword() {
            if (this.temporalNuevoPassword.trim() === '') {
                this.mostrarAlerta({
                    titulo: 'Error',
                    contenido: 'Debe ingresar una nueva contraseña.',
                    botonCerrar: 'Ok',
                    cerrarCallback: () => {
                        this.$refs.temporalNuevoPassword.$el.focus()
                    },
                })
                return
            }

            if (this.temporalNuevoPassword.trim().length < 8) {
                this.mostrarAlerta({
                    titulo: 'Error',
                    contenido: 'La nueva contraseña debe tener al menos 8 caracteres.',
                    botonCerrar: 'Ok',
                    cerrarCallback: () => {
                        this.$refs.temporalNuevoPassword.$el.focus()
                    },
                })
                return
            }

            this.grabando = true

            const respuesta = await UsuariosService.update({
                id: this.$store.state.auth.usuario.id,
                password: this.temporalNuevoPassword.trim(),
                cambiar_password: false,
            })

            if (respuesta.success === true) {
                this.mostrarAlerta({
                    titulo: 'Listo!',
                    contenido: 'La nueva contraseña fue aplicada.',
                    botonCerrar: 'Ok',
                    cerrarCallback: () => {
                        window.location.href = '/'
                    },
                })
            } else {
                this.mostrarAlerta({
                    titulo: 'Error',
                    contenido: `La nueva contraseña no se pudo aplicar:<Br />${respuesta.error}`,
                    botonCerrar: 'Ok',
                    cerrarCallback: () => {
                        this.$refs.temporalNuevoPassword.$el.focus()
                    },
                })
            }
        },
        mostrarAlerta(alertaOpciones) {
            this.alertaOpciones = alertaOpciones
            this.alertaVisible = true
            this.$store.commit('global/SET_MOSTRANDO_ALERTA', true)
        },
        cerrarAlerta() {
            this.alertaVisible = false
            if (this.alertaOpciones.cerrarCallback) {
                this.alertaOpciones.cerrarCallback()
            }
            this.$store.commit('global/SET_MOSTRANDO_ALERTA', false)
        },
        async continuarYAceptarTerminos() {
            if (this.aceptoTerminos === false) {
                this.mostrarAlerta({
                    titulo: 'Error',
                    contenido: 'Debe aceptar los Términos y Condiciones para continuar.',
                    botonCerrar: 'Ok',
                })
                return
            }
            this.grabando = true

            await UsuariosService.update({
                id: this.$store.state.auth.usuario.id,
                tyc_aprobado: this.tyc.id,
            })

            if (this.server === 'backend') {
                this.$store.dispatch('auth/obtenerDatos')
            } else {
                this.$store.dispatch('auth/obtenerDatosPDV')
            }

            this.grabando = false
        },
        async cerrarSesion() {
            this.$store.dispatch('auth/logout')
        },
        fechaTYC() {
            return moment(this.tyc.created_at).format('DD-MM-YYYY')
        },
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false
                this.mobileMenuActive = false
            }

            this.menuClick = false
        },
        onMenuToggle() {
            this.menuClick = true

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
                    if (this.mobileMenuActive === true) {
                        this.overlayMenuActive = true
                    }

                    this.overlayMenuActive = !this.overlayMenuActive
                    this.mobileMenuActive = false
                } else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive
                }
            } else {
                this.mobileMenuActive = !this.mobileMenuActive
            }

            if (typeof event !== 'undefined') event.preventDefault()
        },
        onSidebarClick() {
            this.menuClick = true
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false
                this.mobileMenuActive = false
            }
        },
        onLayoutChange(layoutMode) {
            this.layoutMode = layoutMode
        },
        onLayoutColorChange(layoutColorMode) {
            this.layoutColorMode = layoutColorMode
        },
        addClass(element, className) {
            if (element.classList) element.classList.add(className)
            else element.className += ' ' + className
        },
        removeClass(element, className) {
            if (element.classList) element.classList.remove(className)
            else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ')
        },
        isDesktop() {
            return window.innerWidth > 1024
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static') return !this.staticMenuInactive
                else if (this.layoutMode === 'overlay') return this.overlayMenuActive
                else return true
            } else {
                return true
            }
        },
        async login() {
            if (this.$store.getters['auth/getStatus'] == 'loading') return

            let usuario = this.usuario
            let password = this.password

            await this.$store.dispatch('auth/login', {
                usuario: usuario,
                password,
            })

            if (this.isLogueado) {
                if (chequearRuta(this.$route.name) === false) {
                    this.$router.push('/')
                }
            }
        },
        loginPDV() {
            if (this.$store.getters['auth/getStatus'] == 'loading') return

            let password = this.password

            this.$store.dispatch('auth/loginPDV', {
                password,
            })
        },
    },
    created: async function () {
        this.$http.interceptors.response.use(undefined, function (err) {
            return new Promise(function () {
                if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
                    this.$store.dispatch('auth/logout')
                }
                throw err
            })
        })
    },
    async mounted() {
        EventBus.on('mostrar-alerta', this.mostrarAlerta)

        this.tyc = (await TYCsService.getUltimo()).tyc

        setTimeout(() => {
            if (this.$refs.usuarioInput) this.$refs.usuarioInput.$el.focus()
            if (this.$refs.resetNuevoPassword) this.$refs.resetNuevoPassword.$el.focus()
        }, 1000)

        // setInterval(() => {
        //     this.$store.dispatch('auth/obtenerDatos')
        // }, 5000)
    },
    computed: {
        menu: function () {
            return getMenu(this.$store.state.auth.usuario)
        },
        server: function () {
            if (document.location.pathname.includes('pdv/') || document.location.hostname.includes('pdv.')) {
                return 'pdv'
            }

            return 'backend'
        },
        isLogueado: function () {
            return this.$store.getters['auth/isLogueado']
        },
        isLogueadoPDV: function () {
            return this.$store.getters['auth/isLogueadoPDV']
        },
        faltanTYC: function () {
            return (
                this.$store.getters['auth/isLogueado'] &&
                this.tyc &&
                typeof this.tyc.id !== 'undefined' &&
                this.$store.state.auth.usuario.tyc_aprobado < this.tyc.id
            )
        },
        tienePasswordTemporal: function () {
            return this.$store.getters['auth/isLogueado'] && this.$store.state.auth.usuario.cambiar_password === true
        },
        hasToken: function () {
            return this.$store.getters['auth/hasToken']
        },
        resetToken: function () {
            if (window.location.pathname === '/reset' && window.location.search.includes('?token=')) {
                const value = window.location.search.replace('?token=', '')
                const parts = value.split('&')
                return parts[0]
            }
            return ''
        },
        loginStatus: function () {
            switch (this.$store.getters['auth/getStatus']) {
                case 'loading':
                    return 'Ingresando ...'
                case 'success':
                    return 'Ingreso exitoso!'
                case 'error':
                    return `No fué posible ingresar.${this.server === 'pdv' ? '<br />Verifique la contraseña ingresada.' : ''}`
                default:
                    break
            }
            return ''
        },
        containerClass() {
            return [
                'layout-wrapper',
                {
                    'layout-overlay': this.layoutMode === 'overlay',
                    'layout-static': this.layoutMode === 'static',
                    'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                    'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                    'layout-mobile-sidebar-active': this.mobileMenuActive,
                    'p-input-filled': this.$appState.inputStyle === 'filled',
                    'p-ripple-disabled': true,
                    'login-page': (this.isLogueado === false && this.isLogueadoPDV === false) || this.faltanTYC === true || this.tienePasswordTemporal === true,
                    pdv: this.isLogueadoPDV === true,
                    'tyc-page': this.faltanTYC === true,
                },
            ]
        },
        sidebarClass() {
            return [
                'layout-sidebar',
                {
                    'layout-sidebar-dark': this.layoutColorMode === 'dark',
                    'layout-sidebar-light': this.layoutColorMode === 'light',
                },
            ]
        },
        logo() {
            return 'assets/layout/images/logo.png'
        },
    },
    beforeUpdate() {
        if (this.mobileMenuActive) this.addClass(document.body, 'body-overflow-hidden')
        else this.removeClass(document.body, 'body-overflow-hidden')
    },
    components: {
        AppTopBar: AppTopBar,
        AppProfile: AppProfile,
        AppMenu: AppMenu,
        // AppConfig: AppConfig,
        // AppFooter: AppFooter,
    },
}
</script>

<style lang="scss" scoped>
@import './App.scss';

.login-page {
    display: block !important;
    padding: 30px !important;
    background-color: white;
    text-align: center;
    background-image: url('assets/fondo.png');
    background-size: cover;
    background-position: center;

    .login-container {
        width: 565px;
        height: 390px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -282px;
        margin-top: -195px;
        padding: 0;
        border-radius: 12px;
        background-color: #fafafa;
        box-shadow: 0 7px 8px -4px rgb(0 0 0 / 20%), 0 5px 22px 4px rgb(0 0 0 / 12%), 0 12px 17px 2px rgb(0 0 0 / 14%);

        &.reset-container {
            height: 320px;
        }

        .login-header {
            text-align: center;
            vertical-align: middle;
            width: 260px;
            height: auto;
            position: relative;
            top: -80px;
            left: 50%;
            margin-left: -130px;
            background: #fafafa;
            border: 10px solid #fafafa;
            border-radius: 30px;

            img.logo {
                width: 100%;
            }
        }

        .login-panel-content {
            padding: 12px 98px;
            position: relative;
            top: -80px;

            h2 {
                font-size: 16px;
                font-weight: normal;
                letter-spacing: 0.5px;
                color: #212121;
                margin-top: 0;
                margin-bottom: 1em;
                text-align: center;
            }

            .p-float-label {
                max-width: 300px;
                margin-left: auto;
                margin-right: auto;
            }

            input {
                width: 100%;
            }

            .status {
                color: #333;
            }

            input:-webkit-autofill {
                box-shadow: 0 0 0 50px white inset;
                -webkit-box-shadow: 0 0 0 50px white inset;
                -webkit-text-fill-color: black;
            }

            input:-webkit-autofill:focus {
                box-shadow: 0 0 0 50px white inset;
                -webkit-box-shadow: 0 0 0 50px white inset;
                -webkit-text-fill-color: black;
            }

            input:-webkit-autofill::first-line {
                font-size: 1rem;
                font-family: Roboto;
            }

            .p-button {
                background: #f22667;
                max-width: 300px;

                &.p-button-link {
                    background: transparent;
                }
            }
        }
    }

    @media screen and (max-width: 1024px) {
        .login-container {
            width: 94%;
            height: auto;
            left: 3%;
            top: 100px;
            margin-left: 0;
            margin-top: 0;

            .login-panel-content {
                padding: 12px 30px;
                margin-bottom: -80px;
            }
        }
    }
}

.layout-logo img {
    width: 60%;
}

.cargando {
    img.logo {
        width: 80%;
        max-width: 240px;
        margin-bottom: 20px;
        margin-top: 120px;
    }

    h2 {
        color: white;
    }
}

.cargando.tyc-page {
    img.logo {
        margin-top: 0;
    }
}

.tyc-layout {
    display: flex !important;
    align-items: center;
    height: 100vh;

    h2 {
        margin-bottom: 6px;
    }

    h6 {
        font-size: 12px;
        font-weight: normal;
        letter-spacing: 0.5px;
        color: white;
        margin-top: 0;
        margin-bottom: 2em;
        text-align: center;
    }
}

.tyc-container {
    width: 90%;
    max-width: 800px;
    text-align: left;
    white-space: pre-line;
    background-color: white;
    color: black;
    padding: 25px;
    font-size: 18px;
    margin: 0 auto;
    border-radius: 8px;
    overflow: auto;
    flex-grow: 1;
    line-height: 18px;

    ::v-deep(p) {
        margin: 0 !important;
    }
}

.aviso-layout {
    display: flex !important;
    align-items: center;
    justify-content: flex-start;
    height: 100vh;

    .qrContainer {

        display: flex;
        justify-content: space-around;
        margin-top: 30px;
        font-size: 13px;
        font-weight: bold;

        img.descargar {
            width: 200px;
            margin-top: 8px;
        }

        img.qr {
            width: 180px;
            margin-top: 20px;
        }
    }

}

@media screen and (max-width: 38em) {

    .aviso-container {
        font-size: 15px !important;
        line-height: 18px !important;
    }
    .qrContainer {
        flex-direction: column;
        margin-top: 10px !important;

        img.descargar {
            width: 100% !important;
        }

        img.qr {
            width: 90% !important;
            margin-top: 0px !important;
            margin-bottom: 30px;
        }
    }
}

.aviso-container {
    width: 90%;
    max-width: 700px;
    text-align: left;
    white-space: pre-line;
    background-color: white;
    color: black;
    padding: 25px;
    font-size: 18px;
    margin: 0 auto;
    border-radius: 8px;
    overflow: auto;
    line-height: 22px;
    text-align: center;

    ::v-deep(p) {
        margin: 0 !important;
    }
}

.pedido {
    width: 550px;
    max-width: 90%;
    font-weight: bold;
    margin: 0 auto;
    border: 2px solid red;
    border-radius: 12px;
    padding: 12px;
    background-color: rgba(white, 0.4);
}

.checkboxContainer {
    text-align: left;
    width: 90%;
    max-width: 800px;
    height: 50px;
    padding-top: 16px;
    font-weight: bold;
    color: white;
    flex-shrink: 0;
}

.pdv {
    .layout-topbar {
        left: 0;
    }

    .layout-main {
        margin-left: 0;
    }
}

@media screen and (max-width: 40em) {
    .pdv {
        .layout-main {
            padding: 60px 0.5rem !important;
        }
    }
}

:-webkit-autofill {
    animation-name: onAutoFillStart;
}

:not(:-webkit-autofill) {
    animation-name: onAutoFillCancel;
}

@keyframes onAutoFillStart {
    from {}

    to {}
}

@keyframes onAutoFillCancel {
    from {}

    to {}
}
</style>
